"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdBlockerDetection = void 0;
const tslib_1 = require("tslib");
const ajax_helper_1 = require("./ajax-helper");
const js_logger_1 = require("./js-logger");
/**
 * This class is used to detect ad blockers across browsers
 * It uses two techniques to detect ad blockers
 * 1. CSS bait - This is a hidden element that is injected into the DOM and then checked for visibility or manipulation from the adblocker extension
 * 2. Network bait - This is a HEAD request that is done to a known ad server
 */
class AdBlockerDetection {
    constructor(options = { logLevel: 'error' }) {
        this.isReady = false;
        this.testResult = {
            hasAdBlocker: false,
            error: false,
            detection: 'none',
            cssRuns: 0,
        };
        this.cssBaitClasses = 'adsbygoogle pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links';
        this.cssBaitStyle = 'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important;';
        this.remoteBaitResults = [];
        this.offsetProperty = 'offset';
        this.clientProperty = 'client';
        this.baitTriggers = {
            nullProps: [this.offsetProperty + 'Parent'],
            zeroProps: [],
        };
        this.initLogging = (logLevel) => {
            js_logger_1.logging
                .configure({
                minLevels: {
                    '': logLevel,
                },
            })
                .registerConsoleLogger();
        };
        const { logLevel } = options;
        this.initLogging(logLevel);
        this.logger = js_logger_1.logging.getLogger('ad-block-detection');
        this.baitTriggers.zeroProps = [
            this.offsetProperty + 'Height',
            this.offsetProperty + 'Left',
            this.offsetProperty + 'Top',
            this.offsetProperty + 'Width',
            this.offsetProperty + 'Height',
            this.clientProperty + 'Height',
            this.clientProperty + 'Width',
        ];
        this.baitElement = this.createBaitElement();
        this.isReady = true;
        this.logger.info('AdBlockerDetection is ready');
    }
    createBaitElement() {
        let touchedElement;
        this.baitElement = document.createElement('div');
        this.baitElement.setAttribute('class', this.cssBaitClasses);
        this.baitElement.setAttribute('style', this.cssBaitStyle);
        this.logger.info('Adding HTML bait to DOM');
        window.document.body.appendChild(this.baitElement);
        this.logger.info('HTML bait created');
        // "touching" the elements in order to have them initialized
        for (let i = 0; i < this.baitTriggers.nullProps.length; i++) {
            touchedElement =
                this.baitElement[this.baitTriggers.nullProps[i]];
        }
        for (let i = 0; i < this.baitTriggers.zeroProps.length; i++) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            touchedElement =
                this.baitElement[this.baitTriggers.zeroProps[i]];
        }
        return this.baitElement;
    }
    testABPAtrribute() {
        return document.body.getAttribute('abp') !== null;
    }
    testNullProps(baitElement) {
        let hasNullProps = false;
        for (let i = 0; i < this.baitTriggers.nullProps.length; i++) {
            if (baitElement[this.baitTriggers.nullProps[i]] ==
                null) {
                hasNullProps = true;
                this.logger.info('found adblock null attr: ' + this.baitTriggers.nullProps[i]);
                break;
            }
            if (hasNullProps) {
                break;
            }
        }
        return hasNullProps;
    }
    testZeroProps(baitElement) {
        let hasZeroProps = false;
        for (let i = 0; i < this.baitTriggers.zeroProps.length; i++) {
            if (hasZeroProps) {
                break;
            }
            if (baitElement[this.baitTriggers.zeroProps[i]] ===
                0) {
                hasZeroProps = true;
                this.logger.info('found adblock zero attr: ' + this.baitTriggers.zeroProps[i]);
                break;
            }
        }
        return hasZeroProps;
    }
    testComputedStyle(baitElement) {
        let hasComputedStyle = false;
        if (window.getComputedStyle !== undefined) {
            const baitTemp = window.getComputedStyle(baitElement, null);
            if (baitTemp.getPropertyValue('display') == 'none' ||
                baitTemp.getPropertyValue('visibility') == 'hidden') {
                hasComputedStyle = true;
                this.logger.info('found adblock computedStyle indicator');
            }
        }
        return hasComputedStyle;
    }
    runCssBaitTest() {
        this.testResult.detection = 'css';
        if (!this.isReady) {
            this.logger.error('AdBlockerDetection is not ready');
            this.testResult.error = true;
            return this.testResult;
        }
        if (!this.baitElement) {
            this.logger.error('AdBlockerDetection bait element is not ready');
            this.testResult.error = true;
            return this.testResult;
        }
        this.testResult.cssRuns++;
        if (this.testABPAtrribute()) {
            this.testResult.hasAdBlocker = true;
            return this.testResult;
        }
        if (this.testNullProps(this.baitElement)) {
            this.testResult.hasAdBlocker = true;
            return this.testResult;
        }
        if (this.testZeroProps(this.baitElement)) {
            this.testResult.hasAdBlocker = true;
            return this.testResult;
        }
        if (this.testComputedStyle(this.baitElement)) {
            this.testResult.hasAdBlocker = true;
            this.logger.info('TestComputedStyle has detected an adblock');
            return this.testResult;
        }
        this.logger.info('Ended CSS bait adblock detection');
        this.cleanCssBait();
        return this.testResult;
    }
    cleanCssBait() {
        if (this.baitElement === null) {
            return true;
        }
        try {
            document.body.removeChild(this.baitElement);
            this.logger.info('HTML Bait removed');
        }
        catch (ex) {
            this.logger.warn('An error has happen when trying to clean the bait element');
        }
        this.baitElement = null;
        return true;
    }
    runNetworkBaitTest() {
        var e_1, _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.testResult.detection = 'network';
            if (!this.isReady) {
                this.logger.info('AdBlockerDetection is not ready');
                this.testResult.error = true;
                return this.testResult;
            }
            if (this.testResult.hasAdBlocker) {
                this.logger.info('An adblocker was detected already');
                this.testResult.error = true;
                return this.testResult;
            }
            if (this.testResult.cssRuns === 0) {
                this.logger.warn('The adblocker css bait detection has not been run yet, is advised to run it first');
            }
            this.logger.info('Starting remote url bait adblock detection');
            // use HEAD to reduce the request size
            const baitUrls = [
                {
                    url: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
                    method: 'HEAD',
                },
                { url: 'https://e-10220.adzerk.net/api/v2', method: 'OPTIONS' },
            ];
            try {
                for (var baitUrls_1 = tslib_1.__asyncValues(baitUrls), baitUrls_1_1; baitUrls_1_1 = yield baitUrls_1.next(), !baitUrls_1_1.done;) {
                    const baitUrl = baitUrls_1_1.value;
                    const { url, method } = baitUrl;
                    try {
                        const ajaxRequest = new ajax_helper_1.AjaxHelper({
                            url,
                            method,
                            logger: this.logger,
                        });
                        yield ajaxRequest.send();
                        // the result of the request was successful therefor
                        // the adblocking is not active for this URL
                        this.remoteBaitResults.push(false);
                    }
                    catch (error) {
                        // the result was blocked
                        // the adblocking seems active for this URL
                        this.logger.info('A request has been blocked');
                        this.remoteBaitResults.push(true);
                        // found the first result that is blocked so lets stop the loop
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (baitUrls_1_1 && !baitUrls_1_1.done && (_a = baitUrls_1.return)) yield _a.call(baitUrls_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            // check for any positive result
            this.testResult.hasAdBlocker =
                this.remoteBaitResults.filter(Boolean).length > 0;
            return this.testResult;
        });
    }
    runAllTests() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.isReady) {
                this.logger.info('AdBlockerDetection is not ready');
                this.testResult.error = true;
                return this.testResult;
            }
            const cssBaitResult = this.runCssBaitTest();
            if (cssBaitResult.hasAdBlocker && !cssBaitResult.error) {
                this.cleanCssBait();
                return cssBaitResult;
            }
            return yield this.runNetworkBaitTest();
        });
    }
}
exports.AdBlockerDetection = AdBlockerDetection;
//# sourceMappingURL=ad-block-detection.js.map